// extracted by mini-css-extract-plugin
module.exports = {"status_wrap":"index-module__status_wrap___nHn4c"};